/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  bike_facility_type: '',
  street_buffer_width: '',
  buffer_bike_travel_lane: [],
  usable_bikeway_width: '',
  curbside_management: '',
  buffer_bike_sidewalk: [],
  sidewalk_width: '',
  shared_lane_pavement_markings_present: '',
  lateral_distance_between_markings_and_edge_of_sidewalk_or_parked_cars: '',
  mid_block_conflicts: '',
  special_considerations: [],
  prevailing_roadway_speed: '',
  travel_lanes: '',
  bicycle_tier: '',
  land_use_context: '',
  scores: {}
}

const bicycle = createSlice({
  name: 'bicycle',
  initialState,
  reducers: {
    setBicycleInputs(state, action) {
      const { field, value } = action.payload
      if (
        field === 'buffer_bike_travel_lane' ||
        field === 'buffer_bike_sidewalk' ||
        field === 'special_considerations'
      ) {
        // If filed already includes value remove it / add
        state[field] = state[field].includes(value)
          ? state[field].filter((input) => input !== value)
          : [...state[field], value]
      } else {
        state[field] = value
      }
    },
    setBicycleScores(state, action) {
      const { field, value } = action.payload
      state.scores = { ...state.scores, [field]: value }
    },
    resetBicycleInputs(state) {
      return initialState
    },
    setAllBicycleInputs(state, action) {
      return action.payload
    }
  }
})

export const {
  setBicycleInputs,
  setBicycleScores,
  resetBicycleInputs,
  setAllBicycleInputs
} = bicycle.actions
export default bicycle.reducer
